/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { Card, CardBody, CardCategory, CardTitle, Container, Icon, Row, Col, Spinner } from 'design-react-kit';
import React, { useState, useEffect } from 'react';
import ApiService from '../../../services/api';
import PaginationComponent from '../../utils/pagination_component';
import moment from 'moment';
import env from '../../../env';
import parse from 'html-react-parser';
import { NewsClass } from '../models/news';

const WidgetNews = (props) => {

    const [ widget ] = useState(props.widget);

    const [ newsList, setNewsList ] = useState();
    const [ isLoading, setIsLoading ] = useState(true);
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ totalResults, setTotalResults ] = useState(0);

    const scrollToTop = () => {
        const element = document.getElementById("news-elements-wrapper");
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', alignToTop: true });
        }
    }

    let category;
    let id_tag;
    let id_office;

    let show = widget.data.show_number;    

    let page = props.page || '';    

    if(widget.data.category) {
        if(widget.data.category === 'all') {
            category = "";
        } else {
            category = widget.data.category;
        } 
    }

    if(widget.data.id_tag) {
        id_tag = widget.data.id_tag;
    }
    
    if(widget.data.id_office) {
        id_office = widget.data.id_office;
    } 

    const fetchNewsList = async(page, page_size) => {
        setIsLoading(true); 
        let response;      

        if(category !== undefined) {
            if(show > 4) {
                response = await ApiService.getNewsList(category, page, page_size);
            } else {
                if(category === "") {
                    response = await ApiService.getLatestNews();
                } else {
                    response = await ApiService.getLatestNewsByCategory(category);
                }
            }                
        } else if(id_tag !== undefined) {
            if(show > 4) {
                response = await ApiService.getNewsByTag(id_tag, page, page_size);
            } else {
                response = await ApiService.getLatestNewsByTag(id_tag);
            }
        } else if(id_office !== undefined) {
            if(show > 4) {
                response = await ApiService.getNewsByOffice(id_office, page, page_size);  
            } else {
                response = await ApiService.getLatestNewsByOffice(id_office);  
            }                         
        } 
        setIsLoading(false);           
        
        if(response.results) {
            setNewsList(response.results.map((data) => new NewsClass(data)));
            setTotalResults(response.count);
        } else {
            setNewsList(response);
        }        
   
    }

    useEffect(() => {
        fetchNewsList(currentPage, widget.data.show_number);
    }, [currentPage]);    

    if(isLoading) return <Container>{page !== 'tag' && <Spinner active />}</Container>
    if(newsList && newsList.length === 0) return page !== 'tag' && <Container>Nessun Risultato</Container>;

    if(show > 4) return <>
        {page === 'tag' && newsList && newsList.length !== 0 &&
            <Container className="mt-5 pt-5">
                <h2 className="news-by-tags-title mb-4 px-1">Novità</h2>  
            </Container>
        }
        <h2 className="news-page-title mt-2">{widget.data.label ? widget.data.label : 'Elenco Notizie'}</h2>
        <Container id="news-elements-wrapper" fluid className={widget.data.class + '-news page-news-content'}>
            <Row>
            {newsList && newsList.map((news) => {
                return (
                        <Col key={news.slug} xs='12' lg='4' className="mt-2">
                            <Card className='card-img no-after shadow-sm'>
                            {news.image && news.image !== '' && 
                                news.image.substring(news.image.lastIndexOf('/') + 1) !== 'default.jpg' &&
                                news.image.substring(news.image.lastIndexOf('/') + 1) !== 'default.webp' &&
                                <div className='img-responsive-wrapper'>
                                    <div className='img-responsive img-responsive-panoramic'>
                                        <figure className='img-wrapper'>
                                            <img alt="Copertina Notizia" className="img-fluid" src={env.BACKEND_BASE_URL + news.image || ''} title={news.title} />
                                        </figure>
                                    </div>
                                </div>
                            }   
                                <CardBody className="px-4">
                                    <CardCategory date={moment(news.date_news).format('DD/MM/YYYY')} iconName="it-horn"> 
                                        {news.category.name} 
                                    </CardCategory>
                                    <CardTitle className="fw-semibold"> <a className="news-title-link" href={'/novita/'+ news.category.slug + '/' + news.slug + '/'}>{news.title}</a> </CardTitle>
                                    <div className="mt-2 news-description mb-5">
                                        {parse((news.content.description.description).replace(/(<([^>]+)>)/gi, "").substring(0, 100) + '...')}
                                    </div>
                                    <a className="read-more position-relative" href={'/novita/' + news.category.slug + '/' + news.slug + '/'}>Leggi di più <Icon icon="it-arrow-right" /></a>
                                    <div className="mt-5">
                                    {news.tags && news.tags.map((tag) => 
                                        <div key={tag.slug} className={"chip chip-simple chip-primary me-2"}>
                                            <a className="chip-label" href={"/argomenti/" + tag.slug + '/'}>{tag.name}</a>
                                        </div>
                                    )} 
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>                    
                )
            })}
            </Row>
            <PaginationComponent
                totalResults={totalResults}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                scrollToTop={scrollToTop}
                pageSize={widget.data.show_number || 21}
            />

        </Container>        
    </>;

    return <>
        <h2 className="places-page-title mt-5">{widget.data.label ? widget.data.label : 'Elenco Notizie'}</h2>
        <Container fluid className={widget.data.class + '-news page-news-content'}>
            <Row>
            {newsList && newsList.slice(0, (show/2)).map((news) => {
                return (
                        <Col key={news.slug} xs='12' lg='4' className="mt-2">
                            <Card className='card-img no-after shadow-sm'>
                            {news.image && news.image !== '' && 
                                news.image.substring(news.image.lastIndexOf('/') + 1) !== 'default.jpg' &&
                                news.image.substring(news.image.lastIndexOf('/') + 1) !== 'default.webp' &&
                                <div className='img-responsive-wrapper'>
                                    <div className='img-responsive img-responsive-panoramic'>
                                        <figure className='img-wrapper'>
                                            <img alt="Copertina Notizia" className="img-fluid" src={env.BACKEND_BASE_URL + news.image || ''} title={news.title} />
                                        </figure>
                                    </div>
                                </div>
                            }   
                                <CardBody className="px-4">
                                    <CardCategory date={moment(news.date_news).format('DD/MM/YYYY')} iconName="it-horn"> 
                                        {news.category.name} 
                                    </CardCategory>
                                    <CardTitle className="fw-semibold"> <a className="news-title-link" href={'/novita/'+ news.category.slug + '/' + news.slug + '/'}>{news.title}</a> </CardTitle>
                                    <div className="mt-2 news-description mb-5">
                                        {parse((news.content.description.description).substring(0, 100).replace(/(<([^>]+)>)/gi, "") + '...')}
                                    </div>
                                    <a className="read-more position-relative" href={'/novita/' + news.category.slug + '/' + news.slug + '/'}>Leggi di più <Icon icon="it-arrow-right" /></a>
                                    <div className="mt-5">
                                    {news.tags && news.tags.map((tag) => 
                                        <div key={tag.slug} className={"chip chip-simple chip-primary me-2"}>
                                            <a className="chip-label" href={"/argomenti/" + tag.slug + '/'}>{tag.name}</a>
                                        </div>
                                    )} 
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>                    
                )
            })}
                <Col xs='12' lg='4'>
                {newsList && newsList.slice((show/2), show).map((news) => {
                    return (
                            <Col key={news.slug} xs='12' lg='12'>
                                <Card className="mt-2 shadow-sm">
                                    <CardBody>
                                        <CardCategory date={moment(news.date_news).format('DD/MM/YYYY')} iconName="it-horn"> 
                                            {news.category.name} 
                                        </CardCategory>
                                        <CardTitle className="fw-semibold"> <a className="news-title-link" href={'/novita/'+ news.category.slug + '/' + news.slug + '/'}>{news.title}</a> </CardTitle>
                                        <div className="mt-2 news-description mb-5">
                                            {parse((news.content.description.description).substring(0, 100).replace(/(<([^>]+)>)/gi, "") + '...')}
                                        </div>
                                        <a className="read-more position-relative" href={'/novita/' + news.category.slug + '/' + news.slug + '/'}>Leggi di più <Icon icon="it-arrow-right" /></a>
                                    </CardBody>
                                </Card>
                            </Col>                    
                    )
                })}
                </Col>
            </Row>
        </Container>        
    </>;
}

export default WidgetNews;